import css from 'styled-jsx/css';

export default css`
  .location {
    margin: -2px 0 0 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .text {
    font-size: 0.875em; /* 14/16 */
    margin: 0 0 0 0.2em;
  }

  :global(.rtl) .location :global(svg) {
    margin-left: 0 !important;
    margin-right: -1px;
  }

  :global(.rtl) .text {
    margin: 0 0.2em 0 0;
  }
`;



// WEBPACK FOOTER //
// ./app/common/Location/locationStyles.js